import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

// True when the saved sign-in is readable and not yet expired.
const hasLiveSession = (token) => {
  if (!token) return false;
  try {
    return jwtDecode(token).exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

// The sign-in pages. A signed-in admin goes straight to the dashboard; anyone
// else, including an admin whose saved sign-in has expired, stays here.
//
// The expired case used to navigate to "/" from "/", which re-ran this guard
// on every navigation: hundreds of page changes a second, until Chrome
// throttled navigation and ignored the jump to the dashboard after a correct
// sign-in — the admin had to reload or press Sign in again.
export default function PublicRoutes({ children }) {
  if (hasLiveSession(localStorage.getItem("token"))) {
    return <Navigate to="/dashboard" replace />;
  }
  return <div>{children}</div>;
}
